module.exports = __webpack_public_path__ + "static/media/user.658686a4.svg";